(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["history"]) return;
  try {
    

  // Same DOM hooks as before: #progress / #historically, .progress__item
  // with data-progress, and .history__block with data-historically. The
  // behaviour is unchanged (click a year -> scroll to its card; scrolling
  // highlights the current card) but the "current card" detection is now
  // robust for cards taller than the viewport.
  var historically = document.querySelector('#historically');
  var progress = document.querySelector('#progress');
  var clickableProgressItems = document.querySelectorAll('.progress__item');
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Cache the decade cards once so the scroll handler never re-queries the DOM.
  // The trailing spacer has no data-historically attribute, so it's excluded.
  var historyCards = [].slice.call(historically.querySelectorAll('[data-historically]'));

  // Pin the bar right below the theme's sticky announcement bar + header by setting
  // its sticky `top` to their combined height (both are position:sticky; top:0).
  var stickyTopOffset = 0;
  function setProgressStickyOffset() {
    var announcement = document.getElementById('shopify-section-announcement-bar');
    var header = document.getElementById('shopify-section-header-v2') || document.getElementById('shopify-section-header');
    var offset = 0;
    if (announcement) offset += announcement.offsetHeight;
    if (header) offset += header.offsetHeight;
    stickyTopOffset = offset;
    if (progress) progress.style.top = offset + 'px';
  }
  setProgressStickyOffset();
  window.addEventListener('resize', setProgressStickyOffset);
  window.addEventListener('load', setProgressStickyOffset);

  // Keep the active year pill in view when the nav scrolls horizontally (mobile).
  function childScroll(el, parent) {
    var elRight = el.offsetLeft + el.offsetWidth;
    var viewRight = parent.scrollLeft + parent.clientWidth;
    if (elRight > viewRight) {
      parent.scrollLeft = elRight - parent.clientWidth;
    } else if (el.offsetLeft < parent.scrollLeft) {
      parent.scrollLeft = el.offsetLeft;
    }
  }

  // Mark a single year as active and sync ARIA + horizontal scroll.
  function setActive(index) {
    [].forEach.call(clickableProgressItems, function (el) {
      var on = el.getAttribute('data-progress') === String(index);
      el.classList.toggle('progress__item--active', on);
      el.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && progress.scrollWidth > progress.clientWidth) {
        childScroll(el, progress);
      }
    });
  }

  // The "current" card is the last one whose top has scrolled above the
  // line just beneath the sticky nav.
  function currentIndex() {
    var line = progress.getBoundingClientRect().bottom + 8;
    var current = 1;
    for (var i = 0; i < historyCards.length; i++) {
      if (historyCards[i].getBoundingClientRect().top <= line) {
        current = parseInt(historyCards[i].getAttribute('data-historically'), 10);
      }
    }
    return current;
  }

  // While a click-driven smooth scroll runs, lock the underline to the clicked
  // year so scroll events don't drag it through every card in between.
  var lockedIndex = null;
  var lockTimer = null;
  function releaseLock() {
    lockedIndex = null;
    if (lockTimer) { clearTimeout(lockTimer); lockTimer = null; }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      if (lockedIndex === null) {
        setActive(currentIndex());
      } else if (currentIndex() === lockedIndex) {
        // Target reached early — resume normal scroll tracking.
        releaseLock();
      }
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // If the user takes over scrolling mid-animation, stop holding the year.
  window.addEventListener('wheel', releaseLock, { passive: true });
  window.addEventListener('touchstart', releaseLock, { passive: true });

  // Click a year -> highlight it immediately and scroll its card under the nav.
  [].forEach.call(clickableProgressItems, function (item) {
    item.addEventListener('click', function (event) {
      event.preventDefault();
      var step = item.getAttribute('data-progress');
      var section = document.querySelector('[data-historically="' + step + '"]');
      if (!section) return;
      var top = section.getBoundingClientRect().top + window.pageYOffset - progress.offsetHeight - stickyTopOffset;
      var index = parseInt(step, 10);
      setActive(index);
      if (prefersReduced) {
        window.scrollTo({ top: top, behavior: 'auto' });
        return;
      }
      lockedIndex = index;
      if (lockTimer) clearTimeout(lockTimer);
      // Fallback release in case the target can't scroll fully under the nav
      // (e.g. the last card) so scroll tracking never stays stuck.
      lockTimer = setTimeout(releaseLock, 900);
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  // Initialise the active state on load.
  setActive(currentIndex());

  // Toggle a class once the bar is pinned (used for the bottom border).
  var stickyObserver = new IntersectionObserver(function (entries) {
    entries[0].target.classList.toggle('progress--pinned', entries[0].intersectionRatio < 1);
  }, { threshold: [1] });

  stickyObserver.observe(progress);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      const firstMediaContentId = this.querySelector('.product-media-modal__content img').getAttribute("data-media-id");
      if (activeMedia.getAttribute("data-media-id") != firstMediaContentId) {
        activeMedia.scrollIntoView();
      }

      if (activeMedia.classList.contains('deferred-media')) {
        activeMedia.querySelector('.deferred-media__poster').click();
        const video = activeMedia.querySelector('video');
        if (video) video.play();
      }

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  const getCookie = name => {
    const nameEQ = name + "=";
    const cookieArray = document.cookie.split(";");

    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length);
      }
    }

    return null;
  };

  const checkNBAID = () => {
    const isLogged = getCookie('NBA_ID_authenticated');
    let pdpNBAIdInterval;

    const toggleActionsButtons = () => {
      const nbaIdBtn = document.querySelector('a.nba-id__action');
      const addToCartBtn = document.querySelector('button.product-form__submit');
      const nbaDisclaimerText = document.querySelector('small.nba-id__disclaimer');
      if(addToCartBtn){
        if(nbaIdBtn && isLogged){
          nbaIdBtn.style.display = "none";
          nbaDisclaimerText.style.display = "none"
        }
        else if(nbaIdBtn && !isLogged){
          addToCartBtn.style.display = "none";
          nbaIdBtn.style.display = "flex";
          nbaDisclaimerText.style.display = "flex";
        }
        clearInterval(pdpNBAIdInterval);
      }

    }

    pdpNBAIdInterval = setInterval(toggleActionsButtons, 10);
  };

  checkNBAID();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  setTimeout(() => {
    let shopProductSlider = document.querySelectorAll('.shop_the_look_js');

    shopProductSlider.forEach(( pSlider )=>{
      const parentEl = pSlider.closest('.shop-the-look');
      const pagination = parentEl.querySelector('.swiper-pagination');
      const shopCountSlider = parentEl.querySelector('.shop-position-slider-js');

      var shopCount = new Swiper(shopCountSlider, {
        navigation: false,
        slidesPerView: 10
      });

      var shopProduct = new Swiper(pSlider, {
        navigation: false,
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: pagination,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        },
        thumbs: {
          swiper: shopCount,
        },
      });
    })
  }, 1000);

  shopTheLook = () => {
    var spots = document.querySelectorAll('.shop-the-look [data-spot="index-spot"]');

    spots.forEach((spot) => {
      spot.addEventListener("mouseover", function () {
        // Remove "preview" class from all spots
        spots.forEach((otherSpot) => {
          otherSpot.parentElement.classList.remove("active-spot","preview");
        });

        // Add "preview" class to the currently hovered spot
        spot.parentElement.classList.add("active-spot","preview");

        // Check if the mouse is not over the spot itself
        if (!spot.contains(event.target)) {
          spot.parentElement.classList.remove("active-spot","preview");
        } else {
          spot.parentElement.classList.add("active-spot","preview");
        }
      });

      document.addEventListener("click", function (event) {
        /**if clicked outside spot and its div content*/
        var container = spot.closest(".spots");
        var content = spot.parentElement.querySelector(".shop-the-look__product-card");

        if (!spot.contains(event.target) && !content.contains(event.target)) {
          container.classList.remove("active-spot", "preview");
        }
      });

    });
  };

  shopTheLook();

  } catch(e) { console.error(e); }
})();
})();
